import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {getContractById} from '../../../../services'
import {ContractModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useCompany, useClient, useEnterprise, useTableMaster} from '../../../../hooks'
import {initValues} from '../../../../util/values/recepService'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_RECEP_SERVICE} from '../../../../util/Constants'
const Index: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {enterprise, getEnterpriseList} = useEnterprise()
  const {typeReception, getTypeReceptionList} = useTableMaster()
  const getContractByIdValues = async () => {
    try {
      const response = await getContractById(currentTabItem.idToEdit)
      const data = response.data.data
      type ContractModelKeys = keyof ContractModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as ContractModelKeys]) {
              if (fieldName === 'clienteId') {
                let valueCompania = data['companiaId']
                let valueClient = data['clienteId']
                getClientList({companiaId: valueCompania})
                setValue('clienteId', valueClient)
              } else if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as ContractModelKeys]
                if (valueDep !== null && valueDep !== undefined) {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as ContractModelKeys]
                if (valueDep !== null && valueDep !== undefined) {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else {
                setValue(fieldName, data[fieldName as ContractModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  useEffect(() => {
    getTypeReceptionList()
    getCompanyList()
    getEnterpriseList()
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getContractByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false
  const handleGetClientList = (val: any) => {
    let value = val ? val.value : ''
    getClientList({companiaId: value})
  }

  return (
    <ContentForm isEdit={false} title={TITLE_FORM_RECEP_SERVICE}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañia'
            name='companiaId'
            data={companyList}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clientList}
            disabled={isDisabled}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Empresa recepcionadora'
            name='empresaId'
            data={enterprise}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo recepcionador'
            name='tipoRecepcionador'
            data={typeReception}
            disabled={isDisabled}
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Index
